export default __webpack_public_path__ + "static/media/uploader-abbottNeo-1.b67d1aeb.png";